module.exports = __webpack_public_path__ + "static/media/bookstore_background.4dce95de.png";